import { all, fork } from 'redux-saga/effects';
import { loadSubscriptionsSaga } from './load-subscriptions';
export function* rootSaga() {
    yield all([fork(loadSubscriptionsSaga)]);
}
